import { Card, Box, Typography, Avatar, Grid, useTheme } from "@mui/material";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";

export default function ModernIDCard({ data, school, colors, code, fontcolor }) {
  const items = Array.isArray(data) ? data : [];
  const theme = useTheme();

  return (
    <Box id="emp-id-cards-root">
      <Grid container spacing={2}>
        {items?.map((emp) => (
          <Card sx={{
            width: 320,
            height: 500,
            borderRadius: "28px",
            overflow: "hidden",
            position: "relative",
            fontFamily: "Inter, sans-serif",
            boxShadow: "0 20px 50px rgba(0,0,0,0.18)"
          }} key={emp.id}>

            {/* ===== GRADIENT HEADER LAYER ===== */}
            <Box sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: 180,
              background: colors[emp.id] || theme.palette.primary.main,
            }} >
              <Box sx={{
                position: "absolute",
                top: 0,
                width: "94%",
                height: 90,
                background: colors[emp.id] || theme.palette.primary.main,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 1,
                color: "white"
              }}>

                <Box sx={{
                  bgcolor: "white",
                  borderRadius: 2,
                  p: 1,
                  mr: 1
                }}>
                  <img src={school?.logoUrl || null} width={60} />
                </Box>
                <Box sx={{ color: fontcolor, textAlign: 'center' }}>
                  <Typography variant="subtitle" sx={{ fontWeight: 700, lineHeight: 1.5 }}>
                    {school?.schoolName}
                  </Typography>
                  <Typography variant="caption" sx={{ display: "block", lineHeight: 1.2 }}>
                    {[school?.addressDTO?.addressLine1, school?.addressDTO.city, school?.addressDTO.pincode, school?.addressDTO.state].join(", ")}
                    | Tel: {school?.contactPhone}
                  </Typography>
                </Box>

              </Box>

            </Box>

            {/* ===== CURVED WHITE SHAPE ===== */}
            <Box sx={{
              position: "absolute",
              top: 125,
              left: 0,
              width: "100%",
              height: 120,
              bgcolor: "white",
              borderTopLeftRadius: "60% 100%",
              borderTopRightRadius: "60% 100%"
            }} />

            {/* ===== PHOTO ===== */}
            <Box sx={{
              position: "absolute",
              top: 90,
              width: "100%",
              display: "flex",
              justifyContent: "center"
            }}>
              <Avatar
                src={emp.photo || null}
                sx={{
                  width: 110,
                  height: 110,
                  border: "7px solid white",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.25)"
                }}
              />
            </Box>

            {/* ===== CONTENT ===== */}
            <Box sx={{
              position: "absolute",
              top: 220,
              width: "90%",
              textAlign: "center",
              px: 2
            }}>

              <Typography variant="title2" fontWeight={800}>
                {[emp.firstName, emp.lastName].join(" ")}
              </Typography>

              <Typography sx={{
                bgcolor: colors[emp.id] || theme.palette.primary.main,
                color: "white",
                px: 2.5,
                py: 0.6,
                borderRadius: "20px",
                display: "inline-block",
                mt: 1,
                fontWeight: 600
              }} variant="subtitle2" >
                {emp.experience < 1 ? "" : "Senior"}  {[emp.specialization, "Teacher"].join(" ")}
              </Typography>

              <Box sx={{ textAlign: "left", mt: 3, fontSize: 12 }}>
                <Typography variant="subtitle2"><b>ID</b> : {emp.employeeCode}</Typography>
                {/* <Typography variant="subtitle2"><b>Email</b> : {emp.email}</Typography> */}
                <Typography variant="subtitle2"><b>Phone</b> : {emp.phone}</Typography>
                <Typography variant="subtitle2"><b>Blood</b> : {emp.blood}</Typography>
                <Typography variant="subtitle2"><b>Address</b> : {emp?.addressDTO?.addressLine1}</Typography>
              </Box>

            </Box>

            {/* ===== FOOTER BLOCK ===== */}
            {/* <Box sx={{
              position: "absolute",
              bottom: 0,
              width: "94%",
              height: 90,
              background: colors[emp.id] || theme.palette.primary.main,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 1,
              color: "white"
            }}>
              <Box sx={{ color: fontcolor }}>
                <Typography variant="subtitle" sx={{ fontWeight: 700, lineHeight: 1.5 }}>
                  {school?.schoolName}
                </Typography>
                <Typography variant="caption" sx={{ display: "block", lineHeight: 1.2 }}>
                  {[school?.addressDTO?.addressLine1, school?.addressDTO.city, school?.addressDTO.pincode, school?.addressDTO.state].join(", ")}
                  | Tel: {school?.contactPhone}
                </Typography>
              </Box>
              <Box sx={{
                bgcolor: "white",
                borderRadius: 2,
                p: 1
              }}>
                <img src={school?.logoUrl || null} width={60} />
              </Box>
            </Box> */}
            <Box sx={{ position: "absolute", bottom: 10, right: 20 }}>
              {code === 'QRCode' ? (
                <QRCode value={[emp.id, emp.employeeCode].join("#")} size={70} />
              ) : code === 'Barcode' ? (
                <Barcode width={1} height={60} value={[emp.id, emp.employeeCode].join("#")}
                // format="CODE128"
                />
              ) : null}
            </Box>

          </Card>
        ))
        }
      </Grid>
    </Box>
  );
}
